module.exports = __webpack_public_path__ + "static/media/dialogue.6751d701.glb";